import React, { useEffect, useState } from "react";
import "./../styles/transaction.css";
import AccountLayout from "../layouts/AccountLayout";
import { HashLoader } from "react-spinners";
import { getTransactionHistoryList } from "../api/transaction.api";
import showToast from "../components/toasts/ToastNotification";
import Pagination from "../components/pagination/Pagination";

const ITEMS_PER_PAGE = 8;

const TransactionHistory = () => {
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchTransactions = async () => {
      try {
        setLoading(true);
        const res = await getTransactionHistoryList(50);
        if (res.success) {
          setTransactions(res.data.transactions);
        }
      } catch (error) {
        showToast(error.message, "error");
      } finally {
        setLoading(false);
      }
    };
    fetchTransactions();
  }, []);

  const totalPages = Math.ceil(transactions.length / ITEMS_PER_PAGE);
  const currentTransactions = transactions.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );
  const totalIn = transactions
    .filter((tx) => tx.transactionType === "add")
    .reduce((sum, tx) => sum + (tx.amount || 0), 0);
  const totalOut = transactions
    .filter((tx) => tx.transactionType !== "add")
    .reduce((sum, tx) => sum + (tx.amount || 0), 0);

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage((prev) => prev + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage((prev) => prev - 1);
    }
  };


  return (
    <AccountLayout title={"Lịch sử giao dịch"}>
      <div className="transaction-container">
        <div className="transaction-page-head">
          <h3 className="transaction-title">Lịch sử giao dịch</h3>
          <p className="transaction-subtitle">Theo dõi biến động số dư từ nạp tiền, mua hàng và các hoạt động khác.</p>
        </div>

        <div className="transaction-kpi-grid">
          <div className="transaction-kpi-card">
            <p className="kpi-label">Tổng tiền vào</p>
            <p className="kpi-value add-balance">+{totalIn.toLocaleString()}đ</p>
          </div>
          <div className="transaction-kpi-card">
            <p className="kpi-label">Tổng tiền ra</p>
            <p className="kpi-value sub-balance">-{totalOut.toLocaleString()}đ</p>
          </div>
          <div className="transaction-kpi-card">
            <p className="kpi-label">Tổng giao dịch</p>
            <p className="kpi-value">{transactions.length}</p>
          </div>
        </div>

        {loading ? (
          <div className="loader-container">
            <HashLoader color="var(--hash-loader-color)" size={30} />
          </div>
        ) : (
          <>
            <div className="transaction-table-shell">
              <table className="transaction-table">
                <thead>
                  <tr>
                    <th>Mã giao dịch</th>
                    <th>Số tiền</th>
                    <th>Loại</th>
                    <th>Nội dung</th>
                    <th>Số dư</th>
                    <th>Thời gian</th>
                  </tr>
                </thead>
                <tbody>
                  {currentTransactions.length > 0 ? (
                    currentTransactions.map((tx) => (
                      <tr key={tx.transactionId}>
                        <td>{tx.transactionId}</td>
                        {tx.transactionType === "add" ? (
                          <td>
                            <span className="amount-pill amount-pill-add">
                              +{tx.amount.toLocaleString() || 0}đ
                            </span>
                          </td>
                        ) : (
                          <td>
                            <span className="amount-pill amount-pill-sub">
                              -{tx.amount.toLocaleString() || 0}đ
                            </span>
                          </td>
                        )}
                        <td>
                          {tx.transactionType === "add" ? "Tiền vào" : "Tiền ra"}
                        </td>
                        <td>{tx.note}</td>
                        <td>
                          <span className="amount-pill amount-pill-balance">
                            {tx.balance.toLocaleString() || 0}đ
                          </span>
                        </td>
                        <td>{new Date(tx.updatedAt).toLocaleString()}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="6" className="table-empty-cell">Không có giao dịch nào.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            {totalPages > 1 && (
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPrev={handlePrevPage}
                onNext={handleNextPage}
              />
            )}
          </>
        )}
      </div>
    </AccountLayout>
  );
};

export default TransactionHistory;
